import { TariffDTO } from '../../core/modules/tariffs/tariffs.types';

export type TariffPeriodUnit = 'DAY' | 'MONTH' | 'YEAR';

export interface Tariff extends TariffDTO {
  benefit: number; // Сэкономленная сумма при выборе текущего тарифа, по сравнению с самым дорогим тарифом
}

export type TariffId = Tariff['id'];

export type ConnectionType = 'WIRED' | 'WIRELESS';
export enum ConnectionTypeFullName {
  WIRED = 'tariffs.connection.type.wired.title',
  WIRELESS = 'tariffs.connection.type.wireless.title',
  APK = 'Посредством АПК',
}

export interface TariffsSearchParams {
  kkmModel: string;
  kkmSerial: string;
}

export type TariffsByType = Record<ConnectionType, {
  title: ConnectionTypeFullName;
  tariffs: Tariff[];
}>;
